var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{attrs:{"height":_vm.cardHeight}},[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),_c('v-card-subtitle',[_vm._v(_vm._s(_vm.subtitle))]),_c('v-card-text',[_c('VueApexCharts',{attrs:{"width":_vm.width,"type":_vm.type,"options":_vm.options,"series":_vm.series,"height":`${parseInt(_vm.cardHeight) - 80}px`}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }